var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgwaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M713.5 255.5C627.5 35.5 507.5 -51 507.5 -51L-180.5 -83.5L188.5 1136.5C613.333 1133.17 1629.2 1016.7 1558 999.5C1469 978 1028 968.5 857 802C686 635.5 809.808 501.868 713.5 255.5Z",
    fill: "#C8B1CC",
    fillOpacity: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467 181C307.707 30.9471 16.5 -90 -62 -130L-314.5 59.5L247.5 1172.5C672.333 1169.17 1504.2 1158.2 1433 1141C1344 1119.5 1087 1004.5 916 838C745 671.5 682.5 384 467 181Z",
    fill: "#C8B1CC",
    fillOpacity: 0.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M509.5 452C340 345 32.5 326.5 -106 150L-257 -72L-230 1109.5C194.833 1106.17 1649.7 1107.7 1578.5 1090.5L1577.71 1090.31C1486.55 1068.29 984.5 947.013 814 781C643 614.5 599.17 508.606 509.5 452Z",
    fill: "#C8B1CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgwaves);
export default __webpack_public_path__ + "static/media/bgwaves.70c14b8efc490047abcb27d8fad109cc.svg";
export { ForwardRef as ReactComponent };